/**
 * @file Parametres de la simulation a pas fixe (20 tics/s), grille spatiale, limites et pools.
 */
import type { SimulationConfig } from './types';

const HZ = 20;

export const SIMULATION: SimulationConfig = {
  hz: HZ,
  dt: 1 / HZ,
  /** Si l'onglet a ete suspendu, on rattrape au plus N tics puis on abandonne le reste (le hors-ligne prend le relais). */
  maxCatchUpTicks: 12,
  gridCellSize: 4,
  aimMaxRange: 30,
  limits: { targets: 120, projectiles: 400, pickups: 64, floatingTexts: 40 },
  pools: { projectiles: 512, pickups: 64 },
  defaultSeed: 0xca7_6a11,
};

export const TICK_DT = SIMULATION.dt;
